








































import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { PatientPostPayload } from '@/api/user/types'
import { Route } from 'vue-router'

@Component
export default class ManagePatientAddConfirm extends Vue {
  $store!: ExStore
  pending = false
  inputs = {
    ...(this.$store.getters['user/sessionData'](
      'newPatient'
    ) as PatientPostPayload)
  }

  async handleClickSubmit() {
    if (this.pending) {
      return
    }
    this.pending = true
    try {
      const createdPatient = await this.$api.user.createPatient({
        params: this.inputs
      })
      this.$store.commit('user/setSessionData', { createdPatient })
      this.$router.push({ name: 'ManagePatientAddComplete' })
    } catch (error) {
      //
    } finally {
      this.pending = false
    }
  }

  created() {
    if (!this.inputs) {
      console.error('Invalid session')
      this.$router.push({ name: 'Home' })
      return
    }
  }

  beforeRouteLeave(to: Route, from: Route, next: (allow?: boolean) => void) {
    if (to.name !== 'ManagePatientAdd') {
      this.$store.commit('user/deleteSessionData', 'newPatient')
    }
    next()
  }
}
